<template>
    <el-row v-if="amReady">
        <div class="mb-5 border-bottom">
            <h3>{{ ((!editMode)? $ml.get('create') : $ml.get('edit') ) + ' ' + module.info.caption}}</h3>
        </div>

        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-file-upload
                :control="controller"
                :allowed-ext="['xlsx','xls']"
                :controller="controller"
                :field_span="24"
                :file-size-limit="12"
                :label_span="24"
                field_mark="required"
                label="rate_document"
                name="rate_document"
                rules="required"></dg-file-upload>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-select-field
                :control="controller"
                :field_span="19"
                :label_span="24"
                :options="vendorsList"
                :translateLabels="false"
                field_mark="required"
                label="vendor"
                name="vendor"
                placeholder="CC"
                rules="required"></dg-select-field>

            <dg-radio-field
                :control="controller"
                :field_span="19"
                :label_span="24"
                :options="uploadOptions"
                field_mark="required"
                label="upload_options"
                name="upload_options"
                rules="required"></dg-radio-field>
        </el-col>

        <el-col :span="24" class="mt-5 border-top" v-loading="loadingRequests">
            <el-col :class="$langConfig.cssClass" :span="20" class="mt-4">
                <dg-label-field class="error-field-validate-message" label="fields_do_not_match_the_required_criteria"
                                v-show="!this.validData"></dg-label-field>
            </el-col>
            <el-col :span="4" class="pt-3 text-right">
                <dg-button
                    :click="createModule"
                    :text="actionButtonLabel"
                    :type="actionButtonType"
                    icon="el-icon-plus mr-2"></dg-button>

                <dg-button
                    :click="createModule"
                    icon="el-icon-search mr-2"
                    text="search"
                    type="btn btn-success ml-2"></dg-button>
            </el-col>
        </el-col>
    </el-row>
</template>

<script>
    import Vue from 'vue'
    import {mapState} from 'vuex'
    import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
    import module from './../index.js'

    export default {
        mixins: [fieldController],
        props: {
            editMode: {
                required: true,
                type: Boolean
            },
            onEditCallback: {
                required: false
            },
            onCreateCallback: {
                required: false
            }
        },
        data() {
            return {
                controller: this,
                amReady: true,
                module: {
                    ...module
                },
                dataModel: {},
                vendorsList: [
                    {
                        'label': 'Vomatex',
                        'value': 'Vomatex'
                    },
                    {
                        'label': 'Telcomsa',
                        'value': 'telcomsa'
                    }
                ],
                uploadOptions: [
                    {
                        label: 'clean_previous_rates',
                        value: '1',
                        link_label: 'check_terms_of_service'
                    }
                ]
            }
        },
        computed: {
            ...mapState('ajaxManager', ['loadingRequests']),
            actionButtonLabel: function () {
                if (!this.editMode) {
                    return 'create';
                } else {
                    return 'edit'
                }
            },
            actionButtonType: function () {
                if (!this.validData) {
                    return 'danger';
                } else {
                    return 'primary app-bg-primary'
                }
            }
        },
        methods: {
            createModule() {
                this.validateFields().then(result => {
                    let context = this;
                    let data = {data: this.dataModel};
                    if (this.editMode) {
                        data.id = this.dataToBind.id;
                    }

                    if (result) {
                        let api = (this.editMode) ? 'update' : 'create';
                        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
                            G_toastNotify({
                                type: 'success',
                                title: this.$ml.get(api + 'd'),
                                priority: 'top',
                                timer: 4000
                            });

                            this.amReady = false

                            if (context.editMode) {
                                context.onEditCallback(response.data)
                            } else {
                                Vue.nextTick(() => {
                                    context.amReady = true
                                })
                                if (context.onCreateCallback) {
                                    context.onCreateCallback(response.data)
                                }
                            }
                            // this.$router.push({ name: this.module.stateName + '-module-list', params: { teacherId: response.data.id}}).then( response => {})
                        }).catch(error => {
                            this.setfieldsErrorMessage({
                                fieldsErrors: error.response.data
                            }, this.arefieldsValid);
                        })
                    }
                })
            }
        }
    }
</script>
